import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WellTypeCountChart = _resolveComponent("WellTypeCountChart")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_WellStatusCountChart = _resolveComponent("WellStatusCountChart")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_RecentlyUpdatedWellsList = _resolveComponent("RecentlyUpdatedWellsList")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        xs12: "",
        wrap: "",
        class: "px-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            xs12: "",
            lg6: "",
            class: "py-4 pt-8",
            "align-self": "center"
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-h6" }, "Wells by Type", -1)),
              _createVNode(_component_WellTypeCountChart, { class: "pr-6 pt-4" })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            xs12: "",
            lg6: "",
            class: "py-4 pt-8",
            "align-self": "center"
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-h6" }, "Wells by Status", -1)),
              _createVNode(_component_WellStatusCountChart, { class: "pr-6 pt-4" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        xs12: "",
        class: "py-8 px-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-h6" }, "Recently Updated Wells", -1)),
              _createVNode(_component_RecentlyUpdatedWellsList, { class: "py-4" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}